import { styled } from "@mui/material/styles";

interface GridQuantityContainerProps {
  small?: boolean;
}

export const GridQuantityContainer = styled("div")(
  ({ small = false }: GridQuantityContainerProps) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    padding: "4px 12px",
    font: "normal 600 18px/24px Manrope",
    color: "#465869",
    width: "max-content",
    height: small ? "auto" : "40px",
  })
);

interface GridQuantityLabelProps {
  isValue?: boolean;
}

export const GridQuantityLabel = styled("span")(({ isValue }: GridQuantityLabelProps) => ({
  font: "normal 700 16px Manrope",
  fontWeight: isValue ? 400 : 600,
  marginLeft: isValue ? "8px" : undefined,
}));
